import { rest } from '@0xtorch/core'
import { z } from 'zod'
import { binanceApiEndpoint } from '../constants'
import { symbolSchema } from './schema'

const responseSchema = z.object({
  symbols: z.array(symbolSchema),
})

type FetchSpotSymbolsParameters = {
  readonly proxy?: string
}

const urlPath = '/api/v3/exchangeInfo'

export const fetchSpotSymbols = async ({
  proxy,
}: FetchSpotSymbolsParameters) => {
  const url = new URL(urlPath, binanceApiEndpoint)
  url.searchParams.append('permissions', 'SPOT')

  const response = await rest(
    proxy === undefined
      ? url.toString()
      : `${proxy}${encodeURIComponent(url.toString())}`,
    {
      fetchOptions: {
        method: 'GET',
      },
      schema: responseSchema,
    },
  )

  return response.symbols
}
